import { useState } from 'react'
import { CASHBACK_LANDING_PAGE } from '~/design-system/helpers/utilsValidation'
import { DialogFooter, Link } from '~/design-system/primitives'
import { Button, Dialog, DialogContent, Modal } from '~/design-system/primitives'
import SocioSvg from '~/icons/Socio'

export function ModalMoreInfo() {
  const [isOpenModal, setIsOpenModal] = useState(false)

  function handleOpenModal() {
    setIsOpenModal(true)
  }

  function handleCloseModal() {
    setIsOpenModal(false)
  }

  return (
    <>
      <Modal className="bg-transparent max-w-[1080px]" isOpen={isOpenModal}>
        <Dialog className="bg-white rounded-md max-w-[1080px] pt-2.5 pr-5 pl-7">
          <DialogContent className="h-[70vhh] pt-3 ">
            <div className="flex flex-col w-full mb-1">
              <SocioSvg width="50px" />
              <div className="border-b-2 border-gray-40 p-0 w-full pb-3" />
            </div>

            <div className="flex flex-col w-full gap-5 mt-4">
              <p className="text-sm">
                <b className='font-medium'>
                  Ganhe cashback com o Sócio Swift!
                </b>
              </p>
              <p className="text-sm">
                A cada <b className='font-medium'> R$ 100 em compras </b> até o dia 10 do mês, você ganha <b className='font-medium'> R$ 5 de cashback </b> para usar nas semanas seguintes.
              </p>

              <p className="text-sm">
                Você pode acumular até R$ 60 por mês e usar o saldo em qualquer compra no site, aplicativo ou loja física da Swift.
              </p>

              <Link href={`${CASHBACK_LANDING_PAGE}`} target='_blank' className="m-0 text-start justify-start w-fit">
                Conheça mais sobre o programa.
              </Link>

              <p className="text-sm font-medium">Aproveite e economize!</p>
            </div>
            <DialogFooter>
              <Button className="w-full" onPress={() => handleCloseModal()} isOutlined>
                Fechar
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      </Modal >

      <Link className="whitespace-nowrap" variant="primary" onPress={() => handleOpenModal()}>
        Saiba mais
      </Link>
    </>
  )
}
